import { RequestDataReadOnly } from "../request-data-section/request-data-read-only.content";
import { EvaluationSection } from "../evaluation-section.content";
import { InvoiceSectionReadOnly } from "../invoice-section/invoice-section-read-only.content";
import type { ExternalProviderDashboardVM } from "@shared-kernel/application/ports/external-provider/external-provider-repository";
import type { SubmittedInvoiceData } from "@academy-context/write/application/use-cases/external-provider/invoice-submission/submit-external-provider-invoice";

interface Props {
  data: ExternalProviderDashboardVM;
  onEvaluationSubmitted: () => void;
  optimisticInvoice: SubmittedInvoiceData | null;
}

/**
 * Invoice ReadOnly Phase - Invoice is submitted and under review or paid
 * Shown when status is: INVOICE_TO_VALIDATE_BY_ADMIN, INVOICE_APPROVED, PAID
 * Note: Evaluations remain editable
 */
export const InvoiceReadOnlyPhase = ({ data, onEvaluationSubmitted, optimisticInvoice }: Props) => {
  return (
    <>
      <EvaluationSection
        participationId={data.participation?.id ?? null}
        objectives={data.objectives}
        appraisal={data.appraisal}
        onSubmitted={onEvaluationSubmitted}
      />
      <InvoiceSectionReadOnly data={data} optimisticInvoice={optimisticInvoice} />
      <RequestDataReadOnly data={data} />
    </>
  );
};
